import React, { useCallback, useState, useRef, useEffect, useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { ModalNext, ModalBody, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { useDependencies } from 'gw-portals-dependency-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { ErrorCodes } from 'gw-portals-util-adac-js';
import metadata from './AdacMyDocumentsPage.metadata.json5';
import messages from './AdacMyDocumentsPage.messages';
import AdacDocumentsUpload, { onDocumentsUpload } from '../../components/DocumentsUpload/AdacDocumentsUpload';
import AdacDocumentsList from '../../components/DocumentsList/AdacDocumentsList';
import styles from './AdacMyDocumentsPage.module.scss';
import usePortalModeBasedLabel from '../../hooks/usePortalModeBasedLabel';
import { CommunicationVariablesContext } from 'gw-capability-fnol-adac-react';

function MyDocumentsPage({ history }) {
    const translator = useTranslator();
    const { ClaimService } = useDependencies('ClaimService');
    const [documents, setDocuments] = useState([]);
    const [documentsSending, setDocumentsSending] = useState();
    const [documentsUploadVisible, setDocumentsUploadVisible] = useState();
    const [documentsToSend, updateDocumentsToSend] = useState([]);

    const { communicationVariables } = useContext(CommunicationVariablesContext)
    const { token, sessionUUID, communicationType } = communicationVariables;
    const outerCancel = useRef(null);
    const { showAlert } = useModal();

    let showHistoryTab = true;
    const location = useLocation();
    if (location.state !== undefined) {
        showHistoryTab = location.state.showHistoryTab;
    }

    const handleError = useCallback(
        (title, message) => {
            return showAlert({
                title: title,
                message: message,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }, []
    );


    const Modal = ({ children }) => {
        return (
            <ModalNext isOpen={documentsUploadVisible}>
                <ModalBody>
                    {children}
                </ModalBody>
            </ModalNext>

        );
    };

    const updateDocuments = useCallback(() => {
        if (!token || !sessionUUID) { return; }
        ClaimService.getClaimDocuments(token, sessionUUID)
            .then(setDocuments)
            .catch((error) => {
                if (error.appErrorCode === ErrorCodes.SESSION_EXPIRED) {
                    history.push({
                        pathname: '/sessionexpired'
                    });
                } else {
                    handleError(messages.updateDocumentsFailedTitle, messages.updateDocumentsFailed);
                }
            });
    }, [ClaimService, handleError, sessionUUID, token, history]);

    const onSendDocuments = useCallback(async () => {
        onDocumentsUpload({
            documents: documentsToSend,
            ClaimService,
            updateDocumentsToSend,
            setDocumentsSent: () => {
                setDocumentsUploadVisible(false);
                updateDocumentsToSend([]);
                updateDocuments();
            },
            setDocumentsSending,
            translator,
            token,
            history,
            showAlert
        });
    }, [
        documentsToSend,
        ClaimService,
        updateDocumentsToSend,
        setDocumentsSending,
        setDocumentsUploadVisible,
        translator
    ]);

    const downloadDocument = () => {
        ClaimService.getClaimDocument(token, sessionUUID)
    };

    const recall = useCallback(() => {
        history.push({
            pathname: '/recall'
        });
    }, [token, sessionUUID, history]);

    const redirectToHistoryTab = useCallback(() => {
        history.push({
            pathname: '/history'
        });
    }, [history])

    useEffect(updateDocuments, []);

    const overrides = {
        uploadedDocumentsList: {
            data: documents.filter((d) => !d.sentToPortal_Adac)
        },
        receivedDocumentsList: {
            data: documents.filter((d) => d.sentToPortal_Adac),
            showDocumentType: false
        },
        documentsUploadContainer: {
            visible: documentsUploadVisible
        },
        documentsUploadSpinner: {
            loaded: !documentsSending
        },
        documentsUpload: {
            documentsToSend,
            updateDocumentsToSend,
            visible: !documentsSending,
            outerCancel
        },
        uploadDocumentsButton: {
            onClick: () => setDocumentsUploadVisible(true),
        },
        cancelUploadButton: {
            onClick: () => {
                outerCancel.current();
                setDocumentsUploadVisible(false);
            },
            visible: !documentsSending
        },
        sendDocumentsButton: {
            visible: documentsToSend.length > 0 && !documentsSending,
            onClick: onSendDocuments,
        },
        backButton: {
            onClick: history.goBack
        },
        pageHeaderTitle: {
            content: usePortalModeBasedLabel('pageHeaderTitle')
        },
        documentDownloadButton: {
            onClick: downloadDocument,
            visible: communicationType === 'document_download'
        },
        historyContainer: {
            visible: showHistoryTab
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            documentsupload: AdacDocumentsUpload,
            documentslist: AdacDocumentsList,
            modal: Modal
        },
        resolveCallbackMap: {
            recall,
            redirectToHistoryTab
        }
    };
    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(MyDocumentsPage);
